'use client'

import { Provider } from '@rollbar/react'

import { useEnvContext } from 'next-runtime-env'

export const RollbarProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const {
    NEXT_PUBLIC_ROLLBAR_TOKEN,
    NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_ROLLBAR_ENABLED,
  } = useEnvContext()

  const rollbarConfig = {
    accessToken: NEXT_PUBLIC_ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: NEXT_PUBLIC_APP_ENV,
    enabled: NEXT_PUBLIC_ROLLBAR_ENABLED === 'true', // convert string to boolean
    payload: {
      client: {
        javascript: {
          code_version: '1.0.0',
          source_map_enabled: true,
        },
      },
    },
    ignoredMessages: [
      'ResizeObserver loop completed with undelivered notifications',
    ],
    hostBlockList: ['chameleon.io'],
  }
  return <Provider config={rollbarConfig}>{children}</Provider>
}
